var map = {
	"./ai_coins.json": 8413,
	"./altcoins.json": 1985,
	"./bullrun_crypto.json": 6348,
	"./coins_map.json": 3809,
	"./coins_today.json": 1110,
	"./crypto_presale.json": 9954,
	"./fast_growing_crypto.json": 2202,
	"./long_term.json": 8239,
	"./meme_coins.json": 7187,
	"./new_crypto.json": 1720,
	"./penny_crypto.json": 9500,
	"./trending_coins.json": 358,
	"./upcoming_listings.json": 3948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2057;